export const GETTING_STARTED_COLLECTION_ID = 477
export const INTEGRATING_QUILL_EVIDENCE_ARTICLE_ID = 666
export const TERROR_OUT_OF_GRAMMAR_ID = 49
export const DEDICATED_PRACTICE_IS_AN_INVESTMENT_ID = 48
export const ENCOURAGE_STUDENT_WORK_AT_OWN_PACE_ID = 132
